import { render, staticRenderFns } from "./BtnProgramarCarga.vue?vue&type=template&id=61500c4b&"
import script from "./BtnProgramarCarga.vue?vue&type=script&lang=js&"
export * from "./BtnProgramarCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports